import { ChangeDetectionStrategy, Component, inject } from "@angular/core"

import { Button } from "primeng/button"
import { DialogModule } from "primeng/dialog"

import { MaintenanceService } from "./maintenance.service"

@Component({
    selector: "app-maintenance-dialog",
    imports: [DialogModule, Button],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <p-dialog
            [visible]="maintenanceService.maintenance()"
            [modal]="true"
            [closable]="false"
            [draggable]="false"
            [resizable]="false"
            [closeOnEscape]="false"
            [showHeader]="false"
            [style]="{ width: '36rem', maxWidth: '92vw' }">
            <div class="flex flex-col items-center text-center gap-4 py-8 px-4">

                <div class="flex items-center justify-center w-20 h-20 rounded-full bg-surface-100 dark:bg-surface-800">
                    <i class="pi pi-wrench text-4xl text-primary"></i>
                </div>

                <h1 class="m-0 text-3xl font-bold">On revient très vite !</h1>

                <p class="m-0 text-lg text-muted-color">
                    L'application fait une petite pause pour maintenance.<br/>
                    Merci de votre patience, nous serons de retour très bientôt.
                </p>

                <div class="flex items-center gap-3 mt-2 px-5 py-3 rounded-lg bg-surface-100 dark:bg-surface-800">
                    <i class="pi pi-spin pi-spinner text-xl text-primary"></i>
                    <span class="font-medium">
                        Cette fenêtre se fermera automatiquement<br/>
                        dès que l'application sera de nouveau disponible.
                    </span>
                </div>

                <div class="flex flex-col items-center gap-1 mt-6">
                    <span class="text-sm text-muted-color">
                        Rien ne se passe depuis trop longtemps&nbsp;?
                    </span>
                    <p-button label="Recharger la page" icon="pi pi-refresh" severity="secondary" [text]="true" size="small" (onClick)="reload()" />
                </div>

            </div>
        </p-dialog>`
})
export class MaintenanceDialog {

    protected readonly maintenanceService = inject(MaintenanceService)

    protected reload() {
        window.location.reload()
    }
}
